import "./ScenarioConfirmationModal.scss";
import { WarningIcon } from '../../assets/icons/Icons';

const ScenarioConfirmationModal = ({onConfirm, onCancel}) => {
  return (
    <div className='confirmation-modal-overlay'>
      <div className="confirmation-modal">
        <div className='confirmation-modal-header'>
          <WarningIcon />
          <div className='header-title'>Disconnect Scenario?</div>
        </div>
        <div className='confirmation-modal-content'>
          Disconnecting Scenario will disable schedules and take you back to not connected mode of collect.
        </div>
        <div className='confirmation-modal-actions'>
          <div className='modal-action-button cancel-button' onClick={onCancel}>Cancel</div>
          <div className='modal-action-button confirm-button' onClick={onConfirm}>Disconnect</div>
        </div>
      </div>
    </div>
  )
}

export default ScenarioConfirmationModal
